<template>
    <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]" :id="'test'+plytyp+'x'+bettyp">
      <div data-template="template0" class="wrap-template template0"> <!-- class 'is_rang' allbet clash -->
        <div class="main-handicap">
          <div class="vrow items-center template-title is_fold">
            <div class="play-name col" @click="showLeg()">
              <span class="ellipsis">{{ getTitleCaption() }}</span>
            </div>
            <div style="width: 37px;" @click="setToTop($event)">
              <span class="set_top" style="display: none;">
                <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
              </span>
            </div>
          </div>
          <template v-if="show">
            <div class="handicap">
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap"></span>
                          <span class="bet_handicap yb-family-odds">0</span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'ng0'" :plyType="plytyp" :betType="bettyp" ref="teamng0" :mode="'ab'" /> 
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap"></span>
                          <span class="bet_handicap yb-family-odds">1</span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'ng1'" :plyType="plytyp" :betType="bettyp" ref="teamng1" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap"></span>
                          <span class="bet_handicap yb-family-odds">2</span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'ng2'" :plyType="plytyp" :betType="bettyp" ref="teamng2" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap"></span>
                          <span class="bet_handicap yb-family-odds">3</span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'ng3'" :plyType="plytyp" :betType="bettyp" ref="teamng3" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap"></span>
                          <span class="bet_handicap yb-family-odds">4</span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'ng4'" :plyType="plytyp" :betType="bettyp" ref="teamng4" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap"></span>
                          <span class="bet_handicap yb-family-odds">5</span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'ng5'" :plyType="plytyp" :betType="bettyp" ref="teamng5" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1 no_border_bottom">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap"></span>
                          <span class="bet_handicap yb-family-odds">6+</span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'ng6'" :plyType="plytyp" :betType="bettyp" ref="teamng6" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-undefined no_border_bottom">
                <!---->
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    mapGetters
  } from 'vuex'
  import OddComponents from '../../../components/odd'
  import HandicapComponents from '../../../components/handicap'
  
  import allBetMixin from '../../../mixins/allBet'
  
  export default {
    mixins: [allBetMixin],
    props: {
      allBetEvent: null,
      plytyp: null,
      bettyp: null,
      selectMarket: null,
      removeMarket: null,
      rbinfo: null,
      myMarket: {
        type: Boolean,
        default: false
      },
      isSpecial: {
        type: Boolean,
        default: false
      },
      mode:null
    },
    data() {
      return {
        btypes: [allBetMixin.data().nogBetType, allBetMixin.data().rnogBetType],
        tgBetTitle: {
          '1': ['ALL_BET.LBL_01', 'ALL_BET.LBL_23', 'ALL_BET.LBL_46', 'ALL_BET.LBL_7more'],
          '2': ['ALL_BET.LBL_0', 'ALL_BET.LBL_1', 'ALL_BET.LBL_2', 'ALL_BET.LBL_3more']
        },
        show: true,
      }
    },
    computed: {
      ...mapGetters([
        'foldopenAllBet',
        'foldopenFirstEvent'
      ]),
      newAllBetEvent() {
        // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
        return this.allBetEvent
      }
    },
    watch: {
      foldopenAllBet() {
        if(this.mode=='ab'){
          this.show = (this.$store.getters.foldopenAllBet) ? true : false;
        }
      },
      foldopenFirstEvent() {
        if(this.mode!='ab'){
          this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
        }
      }
    },
    methods: {
      getTitleCaption() {
        var a = 'FT'
        var b = ''
        if (this.plytyp == this.firstHtPlyType) {
          a = '1H'
        }
  
        b = this.sportAllBetLang['ALL_BET.SUBHEADER_NOG']
  
        return b
      },
      showLeg() {
        this.show = (!this.show) ? true : false;
      },
      setToTop(e) {
        this.$parent.setToTop(e);
      },
      addToMyMarket(plytyp, tgBetType) {
        if (this.selectMarket)
          this.selectMarket(this.allBetEvent, plytyp, tgBetType, this.isSpecial)
      },
      removeFromMyMarket(plytyp, tgBetType) {
        if (this.removeMarket)
          this.removeMarket(this.allBetEvent, plytyp, tgBetType, this.isSpecial)
      },
    },
    mounted(){
        if(this.mode=='ab'){
          this.show = (this.$store.getters.foldopenAllBet) ? true : false;
        }else{
          this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
        }
      },
  }
  </script>
  


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-nog.vue